import styled from "styled-components";

import { InlineButton as StyledInlineButton } from "components/atoms/Button";
import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";
import { Label as TypoLabel } from "utils/styling/typography.styled";
export const ModalContainer = styled.div`
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
    background-color: ${colourScheme.primaryLight};
    text-align: center;
    align-items: center;
    border-radius: 0.5rem;
    max-width: 100vw;
    width: 100%;
    max-height: 95vh;
    ${device.md} {
        max-width: 26rem;
        max-height: 90vh;
    }
    & > hr {
        width: 100%;
        color: ${colourScheme.white};
    }
`;

export const Label = styled(TypoLabel)`
    display: inline-flex;
    align-items: center;
    font-size: 1rem;
`;

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
    padding: 1rem 0rem;
    align-items: center;
    width: 100%;
    ${device.md} {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
`;

export const FormGroup = styled.div`
    display: flex;
    align-items: stretch;
    flex-direction: column;
    ${device.md} {
        flex-direction: row;
    }
    ${device.lg} {
        flex-direction: column;
    }
    gap: 0.5rem;
`;

export const ButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: center;
`;

export const TextArea = styled.textarea`
    width: 100%;
    height: 10rem;
    padding: 1rem;
    border-radius: 0.25rem;
    border: 1px solid ${colourScheme.white};
    font-size: 1rem;
    resize: vertical;
`;

export const ImageWrapper = styled.div`
    position: relative;
    max-width: 100%;
    max-height: 20rem;
`;

export const OriginalImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: 0.5rem;
    object-fit: contain;
`;

export const ImagePreview = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    border-radius: 0.5rem;
    object-fit: contain;
    opacity: 0.5;
`;

export const GoldCost = styled.span`
    color: gold;
    font-size: 0.9em;
    margin-left: 0.5rem;
`;

export const InlineButton = styled(StyledInlineButton)`
    margin-left: auto;
    opacity: 0.5;
    cursor: pointer;
`;
